import { appConfig } from '../config/appConfig';

// Minimal logger controlled by the single debug flag in appConfig.
// All console output in the app should go through here.

export const logger = {
  log(...args: unknown[]): void {
    if (appConfig.debug) {
      console.log('[RWE]', ...args);
    }
  },
  warn(...args: unknown[]): void {
    if (appConfig.debug) {
      console.warn('[RWE]', ...args);
    }
  },
  error(...args: unknown[]): void {
    // Errors are always logged regardless of debug flag.
    console.error('[RWE]', ...args);
  },
};
